import React from 'react'
import { Header } from 'semantic-ui-react'
import styled from 'styled-components';
import { Box, Flex } from 'rebass'

import { __ } from '~/i18n'
import Auth from '~/auth0'
import { actions as configActions } from '~/config'
import Button from '~/components/button'

import logic from './logic'


const AccountContainer = styled.div`
  padding-top: 30px;
  padding-bottom: 57px;
  
  .ui.header {
    margin-bottom: 0;
  }  
  
  .sub.header {
    margin-bottom: 12px;
  }
`;

@logic
export default class Account extends React.PureComponent {
  static defaultProps = {
    title: __('Use a Gratify Account'),
    description: __('Sign in to your Gratify account')
  };

  constructor(props) {
    super(props);

    const { auth0Settings, config } = props;

    this.auth = new Auth(auth0Settings, config);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    this.auth.lock.on('authenticated', (authResult) => {
      const { accessToken, idToken } = authResult;

      const { auth0Authenticated } = this.props.actions;
      auth0Authenticated(authResult);
    });

    const handler = () => {
      dispatch(configActions.setRedirectUrl(window.location.href));
    };
    this.auth.lock.on('signin submit', handler);
    this.auth.lock.on('signup submit', handler);
  }

  showLogin = (e) => {
    e.preventDefault();
    this.auth.lock.show({initialScreen: 'login'});
  };

  showSignup = (e) => {
    e.preventDefault();
    this.auth.lock.show({initialScreen: 'signUp'});
  };

  render() {
    const {title, description} = this.props;

    return (
      <AccountContainer>
        <Header>{ title }</Header>
        <Header.Subheader>{ description }</Header.Subheader>
        <Flex flexWrap='wrap' py={ 4 } alignItems={ 'center' } mx={ -4 }>
          <Box px={ 4 } width={ 0.5 }>
            <Button fluid onClick={ this.showSignup }>
              { __("Sign Up") }
            </Button>
          </Box>
          <Box px={ 4 } width={ 0.5 }>
            <Button fluid color='green' onClick={ this.showLogin }>
              { __("Log In") }
            </Button>
          </Box>
        </Flex>
      </AccountContainer>

    );
  }
}
